import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Download, FileCheck2, Loader2 } from 'lucide-react';
import { useToast } from '../../ui/ToastProvider';
import driverApplicationService, { errorMessage } from '../../../services/driverApplicationService';

/**
 * Driver profile card for drivers hired through an application: links back to
 * the review page and downloads the countersigned PDF.
 */
const ApplicationOriginCard = ({ applicationId }) => {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const { url } = await driverApplicationService.getPdfUrl(applicationId, 'final');
      window.location.assign(url);
    } catch (err) {
      toast.error(errorMessage(err, 'The signed application PDF is not available.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 sm:p-6">
      <h3 className="mb-1 flex items-center text-base font-semibold text-gray-900 sm:text-lg">
        <FileCheck2 className="mr-2 h-5 w-5 text-gray-400" aria-hidden="true" /> Driver application
      </h3>
      <p className="text-sm text-gray-600">This driver was hired through an online application (49 CFR 391.21). The signed copy is also stored in their documents.</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button type="button" onClick={download} disabled={busy} className="inline-flex items-center gap-1.5 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> : <Download className="h-4 w-4" aria-hidden="true" />} Signed application (PDF)
        </button>
        <Link to={`/drivers/applications/${applicationId}`} className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
          View application
        </Link>
      </div>
    </div>
  );
};

export default ApplicationOriginCard;
